export default __webpack_public_path__ + "static/media/0064.894651c9.png";